export type IMessageType = 'error' | 'success' | 'warning' | 'info';

export enum eMessageType {
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info',
}
